// plan-16 S02: POSIX path utilities for the virtual filesystem

export function normalize(p: string): string {
  const parts = p.split('/').filter(Boolean)
  const resolved: string[] = []
  for (const part of parts) {
    if (part === '.') continue
    if (part === '..') {
      resolved.pop()
    } else {
      resolved.push(part)
    }
  }
  return '/' + resolved.join('/')
}

export function resolve(input: string, cwd: string): string {
  let raw: string
  if (input === '~' || input.startsWith('~/')) {
    raw = input.slice(1) // ~ → '', ~/x → '/x'
  } else if (input.startsWith('/')) {
    raw = input
  } else {
    raw = cwd + '/' + input
  }
  // Clamp at root
  const n = normalize(raw)
  return n
}

export function join(...parts: string[]): string {
  return normalize(parts.join('/'))
}

export function dirname(p: string): string {
  const n = normalize(p)
  const lastSlash = n.lastIndexOf('/')
  if (lastSlash <= 0) return '/'
  return n.slice(0, lastSlash)
}

export function basename(p: string): string {
  const n = normalize(p)
  const lastSlash = n.lastIndexOf('/')
  return lastSlash === n.length - 1 ? '' : n.slice(lastSlash + 1)
}

export function isSubpath(parent: string, child: string): boolean {
  const np = normalize(parent)
  const nc = normalize(child)
  return nc === np || nc.startsWith(np + '/')
}
